import React from "react";
import ServicePage from "../components/ServicePage";
import { WARDROBE, PHOTOS } from "../lib/assets";

const cfg = {
  slug: "wardrobes",
  testid: "wardrobes-page",
  breadcrumb: "Wardrobes",
  serviceName: "Wardrobes",
  seoTitle: "Wardrobes in Noida & Delhi NCR | DIDIT",
  seoDesc:
    "Custom wardrobes by DIDIT for modern Indian homes in Noida and Delhi NCR — sliding, hinged and walk-in designs with smart internals, transparent costing and a 10-year warranty on modulars.",
  canonical: "https://didithomes.com/wardrobes",
  overline: "Wardrobes",
  h1: "Wardrobes Designed Around Your Space",
  heroSub:
    "Thoughtfully planned wardrobes that make the most of every corner — smart internals, easy access and a finish that feels right for your room.",
  secondaryCta: "Explore Wardrobe Types",
  heroImg: WARDROBE.hero,
  heroAlt: "Floor-to-ceiling fitted wardrobe by DIDIT in a warm modern Indian bedroom",
  introOverline: "The DIDIT approach",
  introH2: "Storage that fits your room and your routine",
  introP:
    "We design wardrobes around your available space, what you need to store and how you use your room each day — balancing hanging, shelving and drawers with a look that sits calmly in the bedroom.",
  introImg: WARDROBE.walkin,
  introAlt: "Walk-in wardrobe interior with organised shelving, drawers and hanging sections",
  chips: ["Available space", "What you store", "Daily routine", "Internals", "Finish", "Budget"],
  optionsOverline: "Wardrobe types",
  optionsH2: "Find the wardrobe that suits your home",
  optionsSub:
    "The right type depends on your room's width, door clearance and how you like to access your things. Here are the configurations we design most often.",
  options: [
    { name: "Sliding Wardrobes", img: WARDROBE.sliding, alt: "Sliding-door wardrobe with flush panels and a mirror section", copy: "Space-saving sliding doors that need no clearance to open — ideal for compact rooms or where a bed sits close to the wardrobe. Options include mirror and panelled fronts." },
    { name: "Hinged Wardrobes", img: WARDROBE.hinged, alt: "Hinged shaker-style wardrobe with framed doors and brass knobs", copy: "Classic hinged doors that open fully for complete visibility and access. A versatile choice that suits both minimal and shaker-inspired looks." },
    { name: "Walk-in Wardrobes", img: WARDROBE.walkin, alt: "Compact walk-in wardrobe with open shelving and a mirror", copy: "An open, boutique-style dressing area with organised zones for clothing, accessories and footwear — where the room allows the space." },
  ],
  ctaH2: "Let's design your wardrobe",
  ctaSub:
    "Tell us about your room, what you need to store and the look you love. We'll plan a wardrobe designed around the way you live.",
};

export default function Wardrobes() {
  return <ServicePage cfg={{ ...cfg, introImg: cfg.introImg || PHOTOS.wardrobe }} />;
}
